import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { chain, SendTracking } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { trackCompletedOrder } from "@MasterBluePrint/tracking";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// the chain is just an array, so it can be modified directly instead of using the helper functions
replaceInChain(chain, SendTracking, props => {
    trackCompletedOrder(props.apiResult.cart, props.getState(), props.cartToUpdate, props.apiResult.shipTo,);

});
